export class CreateDataCatalogInputGlueProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogOwner",
            "baseName": "catalogOwner",
            "type": "CatalogOwner",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateDataCatalogInputGlueProperties.attributeTypeMap;
    }
    constructor() {
    }
}
